module.exports = {
      id: "ic-stochastic-oscillator-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-stochastic-oscillator-usage",
      toString: function () {
        return this.url;
      }
    }